export const checkHourOpacity = (ticketManagerId, userId) =>{
    if (!ticketManagerId) return true

    if (ticketManagerId) return false

    if (ticketManagerId && userId){
        return ticket === userId ? true : false
    }
}